import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconStyleMonochrome';
/** Renders an SVG icon. */
const SvgStyleMonochrome = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M25 17.873c0-2.438-1.222-4.748-3.02-7.012-1.52-1.91-3.314-3.637-4.98-5.34v22.414c4.417-.56 8-4.77 8-10.062m-18 0c0 5.292 3.583 9.503 8 10.061V5.521c-1.666 1.703-3.46 3.43-4.98 5.34C8.223 13.125 7 15.435 7 17.873m20 0C27 24.458 22.164 30 16 30S5 24.458 5 17.873c0-3.114 1.556-5.868 3.455-8.257 1.88-2.366 4.287-4.589 6.054-6.467l.157-.15a2.05 2.05 0 0 1 2.825.15c1.767 1.878 4.173 4.101 6.054 6.467C25.444 12.006 27 14.76 27 17.873"
      />
      <path
        fill="currentColor"
        d="m26.707 17.707-10 10-1.414-1.414 10-10zm-1.5-3.5-8.5 8.5-1.414-1.414 8.5-8.5zm-2-3-6.5 6.5-1.414-1.414 6.5-6.5zm-2-3-4.5 4.5-1.414-1.414 4.5-4.5z"
      />
    </svg>
  );
};
SvgStyleMonochrome.displayName = displayName;
export default SvgStyleMonochrome;
